<script>
  import {useQuery} from "@sveltestack/svelte-query"
  import Message from "../plans/new/parts/Message.svelte";
  import Loading from "../../components/pages/Loading.svelte";

  /**
   * @type {string}
   */
  export let projectId

  /**
   * null means unspecified (retrieves all imports)
   * @type {string|null}
   */
  export let dataType

  const query = useQuery(
    `/api/auto-mps/projects/${projectId}/imports/${dataType}`,
  )

  $: console.log($query.data)
</script>

{#if $query.isSuccess}
  <slot imports={$query.data.imports} />
{/if}
{#if $query.isError}
  <Message type="error">
    インポートデータの取得に失敗しました。
  </Message>
{/if}
{#if $query.isLoading}
  <Loading height="50vh" />
{/if}
